import { debounce as _debounce } from 'lodash';

import { listForPharmacistCautiously } from './index';

export default _debounce(listForPharmacistCautiously, 300);
